import { render, staticRenderFns } from "./InstrInfo.vue?vue&type=template&id=0b61eee3&scoped=true&"
import script from "./InstrInfo.vue?vue&type=script&lang=js&"
export * from "./InstrInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b61eee3",
  null
  
)

export default component.exports